import { Nullable } from 'global';
import { v4 as uuidv4 } from 'uuid';
import { FlowsState, TemplatesState } from '../ui/types';
import {
  Stage,
  FlowId,
  StageId,
  TemplatesResponse,
  UpdateBPFVariables,
  DepartmentsResponse,
  VOTemplatesAndStagesResponse,
  Department,
} from '../api';

export function departmentsDataNormalizer(departmentsRes: DepartmentsResponse): Department[] {
  return departmentsRes?.departments ?? [];
}

export function flowsDataNormalizer(
  flowsRes: VOTemplatesAndStagesResponse['vendorOpportunity']['businessProcessFlows']
) {
  return flowsRes.flows.reduce<FlowsState>((acc, flow) => {
    acc[flow.businessProcessFlowId] = flow.currentStage;
    return acc;
  }, {});
}

export function templatesDataNormalizer(templatesRes: TemplatesResponse, accountId: string) {
  return templatesRes.templates.reduce<TemplatesState>((templatesByDepartmentId, { templates }) => {
    templates.forEach(template => {
      if (template.accountId !== accountId) return templatesByDepartmentId;

      const { stages, ...restTemplate } = template;

      templatesByDepartmentId[template.department.id] = {
        ...restTemplate,
        stages: stages.reduce<Record<StageId, Stage>>((acc, stage) => {
          acc[stage.businessProcessFlowStageId] = stage;
          return acc;
        }, {}),
      };
    });

    return templatesByDepartmentId;
  }, {});
}

export function updateBusinessProcessFlowsDtoNormalizer(options: {
  VOId: string;
  stageId: StageId;
  selectedFlow: Nullable<FlowId>;
  VOTemplatesAndStagesResponse: VOTemplatesAndStagesResponse;
}) {
  const { selectedFlow, VOTemplatesAndStagesResponse, stageId, VOId } = options;

  return VOTemplatesAndStagesResponse.vendorOpportunity.businessProcessFlows.flows.reduce<UpdateBPFVariables>(
    (variables, flow) => {
      if (flow.businessProcessFlowId === selectedFlow) {
        variables.fieldsObj.businessProcessFlows.flows.push({
          currentStage: stageId,
          businessProcessFlowId: selectedFlow,
        });
      } else if (flow.currentStage === null) {
        variables.fieldsObj.businessProcessFlows.flows.push({
          ...flow,
          currentStage: uuidv4(),
        });
      } else {
        variables.fieldsObj.businessProcessFlows.flows.push(flow);
      }

      return variables;
    },
    { VOId, fieldsObj: { businessProcessFlows: { flows: [] } } }
  );
}
